:host {
  @include reset-host;
  @include reset-list;
}

:host .faq-section {
  padding: rem(64) $gutter;

  background: $color-purple-fade;

  @include mq('max', 'md') {
    padding: rem(50) $gutter-mobile;
  }
  // Layout
  .container {
    @include container($max-width);
  }

  .head {
    --title-color: #{$color-purple};
    @include container($max-width-narrow);
    text-align: center;
  }

  .body {
    margin-top: rem(64);
  }

  // Elements
  .buttons {
    display: flex;
    gap: rem(16);
    align-items: center;
    justify-content: center;
  }
}

$faq-items--gap-x: rem(32);
$faq-items--gap-y: rem(24);

:host .faq-items {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  margin: calc((#{$faq-items--gap-y} / 2) * -1) calc((#{$faq-items--gap-x} / 2) * -1);
  margin-bottom: rem(32);

  &-el {
    width: 33.33%;
    padding: calc(#{$faq-items--gap-y} / 2) calc(#{$faq-items--gap-x} / 2);
    @include mq('max', 'lg') {
      width: 50%;
    }
    @include mq('max', 'sm') {
      width: 100%;
    }
  }
}

:host .faq-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: rem(16);

  color: $white;
  text-align: left;

  background: $color-purple;
  border-radius: $radius-sm;

  // Layout
  &-body {
    flex-grow: 1;
  }

  &-foot {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: map-get($spacing-sizes, 2);
  }

  // Elements
  &-title {
    margin-bottom: rem(5);

    font-weight: $fw-medium;
    font-size: $fs-3xl;
    font-family: $ff-title;
    line-height: 1.125;
  }

  &-text {
    font-weight: $fw-regular;
    font-size: $fs-lg;
  }

  &-icon {
    font-size: rem(34);
  }
}
